import React from 'react';
import Edit from '../cruds/Edit';
import DepartmentActivitiesList from './DepartmentActivitiesList';
import RemoteInputDualList from '../components/input/RemoteInputDualList';
import MainContainer from '../components/MainContainer';
import { Switch, Route } from 'react-router-dom';

const ENTITY_NAME = 'departments';
const ENTITY_ROUTE = 'departments/activities';
const TITLE = 'departmentActivities.title';

const CrudEdit = props => (
  <Edit {...props}
    title={TITLE}
    entityName={ENTITY_NAME}
    entityRoute={ENTITY_ROUTE}
    entityId={props.match.params.number + '/activities'}
  >
    <RemoteInputDualList
      from="activities?order=NAME"
      optionLabelName="name"
      name="value"
      label="departmentActivities.activities"
      canFilter
    />
  </Edit>
);

const Substances = props => {
  const basePath = props.match.url;
  return (
    <MainContainer>
      <Switch>
        <Route exact path={basePath} component={DepartmentActivitiesList} />
        <Route exact path={basePath + '/edit/:number'} render={props => <CrudEdit {...props} />} />
        <Route exact path={basePath + '/add'} render={props => <CrudEdit {...props} />} />
      </Switch>
    </MainContainer>
  );
};

export default Substances;



// WEBPACK FOOTER //
// ./src/main/pages/DepartmentActivities.js